import React from "react";
import { Button, Paper, TextField, Grid } from "@mui/material";
import { useMutation } from "@apollo/client";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AGREGAR_PLAZA, OBTENER_PLAZAS } from "../../../../graphql/plazas";
const FrmAgregarPlaza = ({ setOpenDialog, setOpenSnackBar, setErrorGraph }) => {
  const [agregarPlaza] = useMutation(AGREGAR_PLAZA, {
    update(cache, { data: { agregarPlaza } }) {
      const { obtenerPlazas } = cache.readQuery({
        query: OBTENER_PLAZAS,
      });
      cache.writeQuery({
        query: OBTENER_PLAZAS,
        data: {
          obtenerPlazas: [...obtenerPlazas, agregarPlaza],
        },
      });
    },
  });

  const formik = useFormik({
    initialValues: {
      nombre: "",
    },
    validationSchema: Yup.object({
      nombre: Yup.string().required("El nombre de la plaza es requerido"),
    }),
    onSubmit: async (inputData) => {
      try {
        const result = await agregarPlaza({
          variables: {
            input: {
              nombre: inputData.nombre,
            },
          },
        });
        setOpenSnackBar(true);
        setErrorGraph({
          mensaje: result.data.agregarPlaza,
          severity: "success",
        });
        //Si todo sale bien reseteamos el formulario
        formik.resetForm();
      } catch (error) {
        setOpenSnackBar(true);
        setErrorGraph({ mensaje: error.message, severity: "error" });
      }
    },
  });

  const handleOpenDialog = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Paper style={{ padding: 10 }}>
          <Grid container alignItems="flex-start" spacing={3}>
            <Grid item xs={12}>
              <TextField
                id="nombre"
                label="Nombre de Plaza "
                variant="standard"
                value={formik.values.nombre}
                onChange={formik.handleChange}
                fullWidth
              />
              {/* {formik.errors.nombre} */}
            </Grid>
          </Grid>
        </Paper>
        <Button type="submit">Guardar</Button>
        <Button onClick={() => handleOpenDialog()}>Cerrar</Button>
      </form>
    </>
  );
};

export default FrmAgregarPlaza;
